import { useIsMobile } from 'pricing-pages-lib/js/context/IsMobileContext.tsx';
import { MerchCardWrapper } from '../MerchCardSharedComponents';
import ProductTileContent from './ProductTileContent';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductTile = props => {
  const isMobile = useIsMobile();
  if (isMobile) {
    return /*#__PURE__*/_jsx(ProductTileContent, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsx(MerchCardWrapper, {
    children: /*#__PURE__*/_jsx(ProductTileContent, Object.assign({}, props))
  });
};
export default ProductTile;